// This file is AUTOGENERATED, do not edit it manually!!!

export const users = {
    active: 'Actif',
    active_switch_description: 'En désactivant la propriété Actif de l’utilisateur, vous faites deux choses : libérer une licence pour un autre utilisateur et rendre l’utilisateur inactif invisible partout dans le système, sauf sur la page Utilisateurs.',
    add_user: 'Ajouter un utilisateur',
    apply: 'Appliquer',
    assign: 'Ajouter',
    assigned_activities_menu_title: 'Activités assignées',
    can_login: 'Peut se connecter',
    can_login_switch_description: 'En désactivant Peut se connecter, vous refusez seulement à l’utilisateur l’accès au système. L’utilisateur peut toujours être membre ou assigné à un projet. Cette action libérera également une licence si vous en avez besoin.',
    cancel: 'Annuler',
    CanDenyLogin_User_DenyLoginYourself: 'Vous ne pouvez pas désactiver Peut se connecter pour vous-même.',
    CanDenyLogin_User_LastAdministrator: 'Vous ne pouvez pas désactiver Peut se connecter pour un utilisateur qui est le seul administrateur du système.',
    CanDisable_User_DisableYourself: 'Vous ne pouvez pas désactiver Actif pour vous-même.',
    CanDisable_User_LastAdministrator: 'Vous ne pouvez pas désactiver Actif pour un utilisateur qui est le seul administrateur du système.',
    cant_delete_user: 'L’utilisateur \"{0}\" ne peut pas être supprimé',
    cant_login: 'Impossible de se connecter',
    change_password: 'Changer le mot de passe',
    close: 'Fermer',
    convert_title: 'Convertir',
    convert_to_regular: 'Convertir en utilisateur régulier',
    convert_to_regular_title: 'Convertir {0} en utilisateur régulier avec le rôle :',
    convert_to_regular_title_with_job_role: 'Convertir {0} en utilisateur régulier avec le poste :',
    deactivate: 'Rendre inactif',
    deactivateTitle: 'Changer le statut de l’utilisateur en Inactif',
    delete: 'Supprimer',
    delete_confirm: 'Supprimer l’utilisateur \"{0}\" ?',
    delete_skill_title: 'Supprimer la compétence',
    delete_team_title: 'Supprimer l’équipe',
    DeleteRateBtnTitle: 'Supprimer définitivement',
    Disable_Permission_Message: 'Vous êtes sur le point de désactiver une permission dans votre rôle qui vous permet de modifier vos propres permissions et celles des autres utilisateurs.',
    Disable_Permission_Title: 'Vous ne pourrez plus modifier les permissions des utilisateurs.',
    DisplayName_customerId: 'Client',
    DisplayName_email: 'E-mail',
    DisplayName_hourlyRate: 'Taux horaire facturé',
    DisplayName_hourlyRateInternal: 'Taux horaire interne',
    DisplayName_login: 'Connexion',
    email: 'E-mail',
    exclude: 'Exclure',
    filterbystatus_Active: 'Seulement actifs',
    filterbystatus_All: 'Actifs et inactifs',
    filterbystatus_CannotLogin: 'Seulement ne peut pas se connecter',
    filterbystatus_Inactive: 'Seulement inactifs',
    generate: 'Générer',
    guest_portal_title: 'Portail invité.',
    guests_interaction: 'Les invités peuvent uniquement interagir avec le système via',
    guests_license: 'Ils n’ont pas besoin de licence.',
    guests_users_tab_title: 'Invités',
    import_title: 'Importer',
    inactive: 'Inactif',
    jobroles_updated_successfully: 'Les postes ont été mis à jour avec succès',
    lastActivityDate_title: 'Dernière visite',
    licensing_limits_warning: 'Vous ne pouvez pas permettre à cet utilisateur de se connecter car votre licence ne permet pas d’ajouter d’autres utilisateurs pouvant se connecter.',
    name_column_title: 'Nom',
    no_sercurity_logs: 'Cet utilisateur n’a encore aucune entrée',
    password_changed: 'Le mot de passe a été changé.',
    personal_schedule_title: 'Planning personnel',
    regular_users_tab_title: 'Réguliers',
    reload: 'Actualiser',
    remove_confirm: 'Supprimer l’utilisateur ?',
    reset: 'Assigner',
    reset_password_confirmation: 'En cliquant sur « Générer », un nouveau mot de passe sera généré et envoyé par e-mail à l’utilisateur.',
    reset_password_done: 'Le nouveau mot de passe a été généré et envoyé.',
    reset_password_menu_title: 'Générer & envoyer le mot de passe par e-mail',
    reset_password_title: 'Voulez-vous vraiment générer et envoyer le nouveau mot de passe par e-mail ?',
    reset_permissions_confirmation: 'Une fois assigné, l’utilisateur aura le rôle actuel dans tous les projets dont il est membre. L’opération est irréversible.',
    reset_permissions_done: 'Le rôle actuel a été assigné.',
    reset_permissions_menu: 'Assigner le rôle actuel',
    reset_permissions_title: 'Voulez-vous assigner le rôle actuel à tous les projets de l’utilisateur ?',
    security_logs_action: 'Action',
    security_logs_date: 'Date',
    security_logs_modal_title: 'Journal de sécurité pour',
    security_logs_title: 'Journal de sécurité',
    securitylog_msg_GuestConverted: 'Rôle changé de Invité à {0} par {1}.',
    securitylog_msg_LoginChanged: 'Connexion modifiée par l’utilisateur {0}.',
    securitylog_msg_LoginChangedBySelf: 'Connexion modifiée.',
    securitylog_msg_PasswordChanged: 'Mot de passe modifié par l’utilisateur {0}.',
    securitylog_msg_PasswordChangedByRecovery: 'Mot de passe récupéré.',
    securitylog_msg_PasswordChangedBySelf: 'Mot de passe modifié.',
    securitylog_msg_PasswordGenerated: 'Mot de passe généré par l’utilisateur {0}.',
    securitylog_msg_PasswordGeneratedBySelf: 'Mot de passe généré.',
    securitylog_msg_PasswordIncorrect: 'Mot de passe incorrect.',
    securitylog_msg_RecoveryRequest: 'Demande de récupération.',
    securitylog_msg_RoleChanged: 'Rôle changé de {0} à {1} par {2}.',
    securitylog_msg_UserLockout: 'L’utilisateur a été bloqué après des tentatives de mot de passe incorrect.',
    securitylog_msg_UserLockoutDueToInactivity: 'L’utilisateur a été bloqué pour cause d’inactivité.',
    securitylog_msg_UserUnlocked: 'L’utilisateur a été débloqué par l’utilisateur {0}.',
    selected_users: '1#{0} utilisateur sélectionné#{0} utilisateurs sélectionnés',
    Set_skills: 'Ajouter des compétences',
    Set_teams: 'Équipes',
    show: 'Afficher',
    show_other_reasons: 'Afficher d’autres raisons',
    skills: 'Compétences',
    skills_updated_successfully: 'Les compétences ont été mises à jour avec succès',
    skillsDeleteConfirm: 'La compétence sera supprimée des profils d’autres utilisateurs où elle est utilisée',
    spaces: 'Espaces',
    suggest_deactivate: 'Cependant, vous avez la possibilité de rendre l\'utilisateur inactif, ce qui supprimera sa visibilité dans tout {brandName}, sauf sur la page Utilisateurs et dans l\'historique d\'affectation des projets et des tâches. Cette action libérera une licence pour un autre utilisateur.',
    teams: 'Équipes',
    teams_updated_successfully: 'Les équipes ont été mises à jour avec succès',
    teamsDeleteConfirm: 'L\'équipe sera supprimée des équipes de chaque utilisateur',
    TimerText: '1#{0} seconde#{0} secondes',
    unlock: 'Déverrouiller',
    user_conversion_done: '{0} a été converti avec succès.',
    user_conversion_title: 'Conversion d\'utilisateur',
    user_duplicate_email_error: 'Un utilisateur avec l\'e-mail spécifié existe déjà',
    user_duplicate_login_error: 'Un utilisateur avec l\'identifiant spécifié existe déjà',
    user_licensing_limits_warning: 'Vous ne pouvez pas activer Peut se connecter pour cet utilisateur car il n\'y a plus de licences disponibles.',
    User_NotFound_Title: 'Utilisateur demandé non trouvé',
    userRates: 'Historique des tarifs',
    userRates_changed_by: 'Modifié par',
    userRates_date: 'Date du changement',
    userRates_hourlyRate: 'Taux horaire facturable',
    userRates_hourlyRateInternal: 'Taux horaire interne',
    userRates_title: 'Historique des tarifs pour {0}',
};
